import React from 'react';
import ComponentList from './componentList';

const ContentfulStaticComponent = ({ component = 'Workshop List', configurationOptions }) => {
  const componentName = component.replace(/ /gi, '');

  const Component = ComponentList[componentName];

  return Component ? <Component {...configurationOptions} /> : null;
};

export default ContentfulStaticComponent;
